var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("\n    陕ICP备05007537号\n    Copyright © 2012-2014 BMY.COM.CN All Rights Reserved\n  ")])])}]

export { render, staticRenderFns }